// i18n 지원 - Folder Template extension 과 함께 사용해야 편함.
let _i18n = {
  languages: {
    EN : { flags: 'us', desc: 'English' },
    KO : { flags: 'kr', desc: '한국어' },
    // JP : { flags: 'jp', desc: 'Japanese' },
  },
  lang: 'EN',
  getLanguage() { return _i18n.languages; }, // readonly 로 해야 하는데...
  setLang(lang) { return (_i18n.languages[lang]) && (_i18n.lang = lang) && (localStorage['UWSS_LANG'] = lang); },
  getLang(comps, opt_lang='') {
    try {
      if(opt_lang) { return comps[opt_lang] }
      return comps[_i18n.lang] && _i18n.lang || 'EN';
    } catch (e) { console.log(e) }
  },
}

const SetLang = _i18n.setLang
const GetLang = _i18n.getLanguage
const LangStatus = _i18n.lang

const builder = (comps, opt_lang='') => {
  // Critical Error
  // if(typeof yourVariable !== 'object' || yourVariable === null) {
  // }
  for(let k in comps) {
    if(opt_lang && k != opt_lang) {
      continue;
    }
    // console.log(opt_lang, k)
    comps[k].mixins = [
      {
        props: ['i18n'],
        computed: { i18n_data() { return {}; } },
        methods: { i18n_msg(key, args) { return (this.i18n_data[key] && this.i18n_data[key][_i18n.lang]) && this.i18n_data[key][_i18n.lang](args) || ''; } },
        // methods: { i18n_msg(key, args) { return (this.i18n_data[key] && this.i18n_data[key][this.i18n]) && this.i18n_data[key][this.i18n](args) || ''; } },
        mounted() { this.i18n_data._lang = this.i18n; }
      }
    ];
  }
  // 지원 언어와 comps 확인
  return {
    template: `<component :is="i18n" :i18n="i18n_lang" v-bind="$attrs"></component>`,
    // template: `<div><component :is="i18n"></component></div>`,
    components: comps,
    data: () => ({ _i18n_lang: _i18n }),
    computed: { i18n() { return _i18n.getLang(comps, opt_lang); }, i18n_lang() { return _i18n.lang; } },
    methods: { setlang(lang) { _i18n.setLang(lang); } }
  };
}

// Initialize Language
_i18n.setLang(localStorage['UWSS_LANG'] || 'EN');
if(['KR', 'EN'].indexOf(navigator.language.substring(0,2).toUpperCase()) > -1) { navigator.language.substring(0,2).toUpperCase() }

export default builder
export { SetLang, GetLang, LangStatus };
